var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value !== '0')?_c('i',{staticClass:"fas fa-circle",class:_vm.pdrClass}):_vm._e(),_vm._v(" "),(_vm.params.value !== 0)?_c('span',[_vm._v(_vm._s(_vm.pdrStatus))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f703566","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/components/PdrStatusRenderer.vue
// module id = null
// module chunks = 